import { render } from "./StocksExpirations.vue?vue&type=template&id=fd31856a&scoped=true&ts=true"
import script from "./StocksExpirations.vue?vue&type=script&lang=ts"
export * from "./StocksExpirations.vue?vue&type=script&lang=ts"

import "./StocksExpirations.vue?vue&type=style&index=0&id=fd31856a&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd31856a"]])

export default __exports__